import { useT } from "@shared/client/locale";
import { openConsentPreferences } from "@shared/lib/consent";

/** Rouvre le panneau « Gestion des cookies » (pieds de page, politique). */
export function ConsentSettingsLink({ className, children }: { className?: string; children?: React.ReactNode }) {
  const t = useT();
  return (
    <button className={className} onClick={openConsentPreferences} type="button">
      {children ?? t.common.consent.settings}
    </button>
  );
}
